import React from 'react';

interface OwnProps {
  isMain?: boolean;
  scrollable?: boolean;
  classNames?: string;
}

type IProps = OwnProps;

const DialogSection: React.FC<IProps> = (props) => {
  const className = `Dialog__InnerSection ${
    props.isMain ? 'section_main ' : ''
  } ${props.scrollable ? 'section_scrollable ' : ''} ${props.classNames || ''}`;
  return <div className={className}>{props.children}</div>;
};

export default DialogSection;
